/* eslint-disable no-restricted-imports */

import GameFooter from './GameFooter';
import GameHeader from './GameHeader';
import GameBody from '../../GameBody';
import GameCurrency from '../../GameCurrencySelect/useGameCurrencySelect/GameCurrency';

type Props = {
  gameCurrencySelect: GameCurrency;
  translations: Record<string, string>;
};

const GameBlock: FC<Props> = ({ translations, gameCurrencySelect }) => (
  <div className="rounded-moon-s-sm bg-popo px-4 py-0">
    <GameHeader />
    <GameBody isDesktop />
    <GameFooter
      gameCurrencySelect={gameCurrencySelect}
      translations={translations}
    />
  </div>
);

export default GameBlock;
